<h1 mat-dialog-title>
</h1>
<div mat-dialog-content>
	<swiper [config]="config" style="height: auto; width: 100%;">
		<div class="swiper-wrapper">
		    <div class="swiper-slide"><img src="assets/img/affiche_gestes_barrieres_1.png" alt=""></div>
		    <div class="swiper-slide"><img src="assets/img/affiche_gestes_barrieres_2.png" alt=""></div>
		    <div class="swiper-slide"><img src="assets/img/affiche_gestes_barrieres_3.png" alt=""></div>
		    <div class="swiper-slide"><img src="assets/img/affiche_gestes_barrieres_4.png" alt=""></div>
		    <div class="swiper-slide"><img src="assets/img/affiche_gestes_barrieres_5.png" alt=""></div>
		    <div class="swiper-slide"><img src="assets/img/affiche_gestes_barrieres_6.png" alt=""></div>
		</div>
		<!-- Add Pagination -->
		<div class="swiper-pagination"></div>
		<!-- Add Arrows -->
		<!--div class="swiper-button-next"></div>
		<div class="swiper-button-prev"></div-->
	</swiper>
</div>
<div mat-dialog-actions>
  	<button mat-button class="covid_close appbutton" [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</div>